<template>
  <div>
    <BannerManage :title="'首页轮播'" :position="'index-banner'" />
    <BannerManage :title="'首页BP'" :position="'project-bestpractice-index'" />
    <BannerManage :title="'Competitions轮播'" :position="'project-home-top'" />
    <BannerManage :title="'Pioneer轮播'" :position="'pioneer-banner'" />
    <BannerManage :title="'News轮播'" :position="'News-Banner'" />
    <BannerManage
      :title="'competition右侧'"
      :position="'project-home-top-recommend'"
    />
  </div>
</template>

<script>
import BannerManage from "../../componentSet/BannerCarousel.vue";
export default {
  components: {
    BannerManage,
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/admin/content/BannerManage.vue